<template>
  <div class="zone-row">
    <div class="zone-label">{{ zone.name }}</div>
    <div class="zone-bar-wrap">
      <div class="zone-bar-bg">
        <div
          class="zone-bar-fill"
          :style="{ width: zone.percentage + '%', background: zoneColor }"
        ></div>
      </div>
      <div class="zone-time">{{ formattedTime }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ZoneBar",
  props: {
    zone: {
      type: Object,
      required: true,
      // { name: 'Zone 5', time: 2.1, percentage: 15 }
    },
  },
  computed: {
    zoneColor() {
      // CSS에서 제공된 색상 순서대로 적용
      const colors = ["#49DE80", "#24D3EE", "#F59E0C", "#EF4444", "#8B5CF6"];
      const zoneIndex = parseInt(this.zone.name.slice(-1)) - 1; // Zone5 -> 5 -> index 4
      return colors[zoneIndex] || "#8B5CF6"; // 기본값
    },
    formattedTime() {
      const totalMinutes = Math.floor(this.zone.time);
      const seconds = Math.round((this.zone.time - totalMinutes) * 60);
      return `${totalMinutes}분 ${seconds}초`;
    },
  },
};
</script>

<style scoped>
.zone-row {
  display: grid;
  grid-template-columns: 60px 1fr;
  gap: 6px;
  align-items: center;
}

.zone-label {
  color: #8e8e8e;
  font-size: 14px;
}

.zone-bar-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
}

.zone-bar-bg {
  flex: 1;
  height: 20px;
  background: #333;
  border-radius: 10px;
  overflow: hidden;
}

.zone-bar-fill {
  height: 100%;
  border-radius: 10px;
  transition: width 0.3s ease;
}

.zone-time {
  color: #fff;
  font-size: 14px;
  width: 70px;
  text-align: right;
  flex-shrink: 0;
  white-space: nowrap;
}
</style>
